import { ICellRendererParams } from '@ag-grid-community/core';
import { ReactElement } from 'react';
import { WindowsUpdate } from '../../models/windows-update';
import NullValueCellRenderer from './NullValueCellRenderer';
import { useTranslation } from 'react-i18next';
import { Typography } from '@getgo/chameleon-web-react-wrapper/register';

function IsMandatoryCellRenderer({ value }: ICellRendererParams<WindowsUpdate, string[]>): ReactElement | null {
  const { t } = useTranslation();
  if (value === null) return <NullValueCellRenderer />;
  return (
    <Typography variant="body-small">
      {value ? t('deviceDetails.grid.windows.yes') : t('deviceDetails.grid.windows.no')}
    </Typography>
  );
}

export default IsMandatoryCellRenderer;
